// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2leOI","select":"Header_select__1RK-y","clinic":"Header_clinic__Y65Af"};